import type { SalesChannelContext } from '@hubblecommerce/hubble/platforms/shopware/api-client'
import type { HblCustomer } from '@/utils/types'
import { hblMapCustomerAddress } from '#imports'

export function hblMapCustomer (customer: SalesChannelContext['customer']): HblCustomer {
    const obj: HblCustomer = {
        // @ts-ignore
        salutationId: customer.salutationId,
        // @ts-ignore
        name: `${customer.firstName} ${customer.lastName}`,
        // @ts-ignore
        firstName: customer.firstName,
        // @ts-ignore
        lastName: customer.lastName,
        // @ts-ignore
        dateOfBirth: customer.birthday,
        // @ts-ignore
        email: customer.email,
        // @ts-ignore
        isGuest: customer.guest,
        // @ts-ignore
        customerReferralSource: customer.customFields?.customer_referral_source,
        // @ts-ignore
        improvedDeliveryService: customer.customFields?.customer_permission_deliverer_data,
        // @ts-ignore
        customerIban: customer.customFields?.custom_customer_iban,
        // @ts-ignore
        crifBuergelExcludeFromCheck: customer.customFields?.hrzn_crif_burgel_exclude_from_check,
        // @ts-ignore
        queryViaPhone: customer.customFields?.customer_query_via_phone,
        // @ts-ignore
        permissionOutbound: customer.customFields?.customer_permission_outbound,
        // @ts-ignore
        hasSubscription: customer.customFields?.has_subscription,
        // @ts-ignore
        defaultPayment: customer.defaultPaymentMethodId,
        // @ts-ignore
        customerNumber: customer.customerNumber
    }

    if (customer?.defaultShippingAddress != null) {
        // Todo patch api client
        // @ts-ignore
        Object.assign(obj, { shippingAddress: hblMapCustomerAddress(customer.defaultShippingAddress) })
    }

    if (customer?.defaultBillingAddress != null) {
        // Todo patch api client
        // @ts-ignore
        Object.assign(obj, { billingAddress: hblMapCustomerAddress(customer.defaultBillingAddress) })
    }

    /*
     * Remove id and compare mapped shipping and billing address to tell if they are the same or not
     */
    if (obj.shippingAddress != null && obj.billingAddress != null) {
        const { id: shippingId, ...cleanedShippingAddress } = obj.shippingAddress
        const { id: billingId, ...cleanedBillingAddress } = obj.billingAddress
        obj.billingSameAsShipping = JSON.stringify(cleanedShippingAddress) === JSON.stringify(cleanedBillingAddress)
    }

    return obj
}
